export enum StatisticId {
    TotalMoneyGained = "total-money-gained",
    CardsPlayed = "cards-played",
    CardsPlayedByLevel = "cards-played-by-level",
    LevelsCompleted = "levels-completed",
    CardsPlayedPerType = "cards-played-by-type",
}